import { Component, Inject, Input, NgModule, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustBusService } from 'src/app/services/customer-search-bussiness-logic.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlightSmartSearchDropDownComponent } from 'src/app/components/common/alight-smart-search-drop-down/alight-smart-search-drop-down.component';
import { REGEX } from 'src/app/models/Constants';
import { ApiService } from 'src/app/services/api.service';
import { ValidValues } from 'src/app/models/ValidValues';





@Component({
  selector: 'app-database-selector',
  templateUrl: './database-selector.component.html',
  styleUrls: ['./database-selector.component.scss']
})
export class DatabaseSelectorComponent implements OnInit {

  databaseSelectorForm: FormGroup = new FormGroup({});
  public udpDataBaseName: string = "";
  public tbaLifeCycle: string = "";
  public transId: string = "";
  private tempClient: string = "";
  public crrUdpDataBaseName: string = "";
  public crrTbaLifeCycle: string = "";
  public crrTransId: string = "";
  public validValuesList: ValidValues[] = [];
  public isTBAClient: boolean = true;
  public isClientSelected = false;
  public enableResetToDefault = false;
  public isDatabaseSelectorApiFailure = false;
  public errorMessage = "";

  public disable: boolean = false;

  constructor(
    public rootService: RootScopeService,
    public customerService: CustBusService,
    private dialogRef: MatDialogRef<void>,
    private fb: FormBuilder,
    private apiService: ApiService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }



  ngOnInit(): void {

    this.disable = false;
    this.databaseSelectorForm = this.fb.group({
      clientId: new FormControl(),
      udpDatabaseName: new FormControl('', Validators.required),
      tbaLifeCycle: new FormControl(),
      transId: new FormControl(),

      clientName: new FormControl(null, [
        Validators.required
      ])
    });

    this.getTBALifeCycleList();
  }

  getTBALifeCycleList() {
    this.apiService.getDataByCommonKeyValueApi("TBAGUI-LIFECYCLE").subscribe({
      next: (res: any) => {
        if (res && res?.data && res?.data?.body) {
          this.validValuesList = res?.data?.body;
          console.log(this.validValuesList)
        }
      },
      error: (err) => {
        this.rootService.captureLogsDb("There was a problem loading the data. Try again." + err, "Error");
        this.errorMessage = "There was a problem loading the data.";
        this.isDatabaseSelectorApiFailure = true;
        return null;
      }
    })
  }


  getTBALifecycleName(Id) {

    let name = this.validValuesList.find(x => x.fieldValue == Id)?.fieldValueDescription;
    return name
  }

  /* istanbul ignore next */
  onClientDropDownChange(event) {

    this.disable = true;
    console.log(event)
    let selectedClient = event?.['value'];
    if (this.tempClient != selectedClient) {
      this.tempClient = selectedClient;
      // clear field
      this.transId = "";
      this.udpDataBaseName = "";
      this.tbaLifeCycle = "";
      this.crrTransId = "";
      this.crrUdpDataBaseName = "";
      this.crrTbaLifeCycle = "";
      this.isClientSelected = true;

    }
    console.log(selectedClient)
    this.udpDataBaseName = this.getMappedValFromClientSystemData("UDP", "TEST-CFG", selectedClient, "COMMON");
    this.tbaLifeCycle = this.getMappedValFromClientSystemData("TBA-GUI", "LIFECYCLE", selectedClient, "COMMON");
    this.crrTbaLifeCycle = this.tbaLifeCycle;
    this.crrUdpDataBaseName = this.udpDataBaseName;
    if (this.tbaLifeCycle != 'NA' && this.tbaLifeCycle != '' && this.tbaLifeCycle != undefined) {
      this.transId = this.getMappedValFromClientSystemData("TBA-GUI", "TRANS-ID", selectedClient, "COMMON");
      this.crrTransId = this.transId;
      this.isTBAClient = true;
      this.databaseSelectorForm.controls['tbaLifeCycle'].setValidators([Validators.required]);
      this.databaseSelectorForm.controls['transId'].setValidators([Validators.required]);
    }
    else {
      this.isTBAClient = false;
      this.tbaLifeCycle = "";
      this.crrTbaLifeCycle = "";
      this.databaseSelectorForm.controls['tbaLifeCycle'].clearValidators();
      this.databaseSelectorForm.controls['transId'].clearValidators();
    }
    this.databaseSelectorForm.controls['tbaLifeCycle'].updateValueAndValidity();
    this.databaseSelectorForm.controls['transId'].updateValueAndValidity();


  }
  onFocus(event) {

  }

  resetFormOnClientChange(data) {
    //this.createCustomerSearchForm({ clientId: data['value'] });
    this.errorMessage = "";
  }

  closeDatabaseSelector() {
    this.dialogRef.close();
  }

  submitDbChange() {
    this.enableResetToDefault = true;
    this.isDatabaseSelectorApiFailure = true;
    this.errorMessage = "There was a problem saving the data.";
  }

  resetToDefault() {
    this.enableResetToDefault = true;
    this.isDatabaseSelectorApiFailure = true;
    this.errorMessage = "There was a problem loading the data.";
  }

  getMappedValFromClientSystemData(systemName, attributeName, clntId, domainName?) {

    let data = this.rootService.clientSystemIds.find(x => x.clientId == clntId);
    let key = '';
    if (domainName && domainName != 'undefined') {
      key = clntId + "-" + systemName + "-" + domainName + '-' + attributeName;
    }
    else {
      key = clntId + "-" + systemName + "-" + 'COMMON' + '-' + attributeName;
    }
    if (data?.data?.[key]) {
      return data?.data[key]?.targetSystemAttributeValue;
    }
    else
      return 'NA';
  }



}
